var React = require('react');

function PhoneIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"phone-icon"),React.createElement("path",{"d":"M38.61,33.8S35.94,37.44,35,38.6c-1.9,2.34-6,3.92-12,.69A61.22,61.22,0,0,1,4.74,23.62,25.54,25.54,0,0,1,.13,13.24,8.62,8.62,0,0,1,1.7,6.49c.48-.57,2.06-2.16,2.06-2.16L6.4,2.28,15.51,13l-3.24,3A4.34,4.34,0,0,0,12,22.06a47.14,47.14,0,0,0,7.34,7.05c4.5,3.59,8.33-3.73,8.33-3.73Z","key":1}),React.createElement("polygon",{"points":"7.23 1.62 9.51 0 18.33 10.54 16.34 12.27 7.23 1.62","key":2}),React.createElement("polygon",{"points":"28.24 24.48 29.83 22.18 40.97 30.86 39.38 32.97 28.24 24.48","key":3})]);
}

PhoneIcon.defaultProps = {"width":"40.96","height":"41.12","viewBox":"0 0 40.96 41.12"};

module.exports = PhoneIcon;

PhoneIcon.default = PhoneIcon;
